export const defaultActivityPoints = [
  {
    activityId: 'contact_added',
    points: 5,
  },
  {
    activityId: 'phone_conversation',
    points: 8,
  },
  {
    activityId: 'meeting_scheduled_first',
    points: 6,
  },
  {
    activityId: 'meeting_scheduled_second',
    points: 4,
  },
  {
    activityId: 'meeting_successful_first',
    points: 10,
  },
  {
    activityId: 'meeting_successful_second',
    points: 8,
  },
  {
    activityId: 'site_visit_scheduled_first',
    points: 7,
  },
  {
    activityId: 'site_visit_scheduled_second',
    points: 5,
  },
  {
    activityId: 'site_visit_successful_first',
    points: 12,
  },
  {
    activityId: 'site_visit_successful_second',
    points: 10,
  },
  {
    activityId: 'property_specs',
    points: 8,
  },
  {
    activityId: 'quotation_shared',
    points: 12,
  },
  {
    activityId: 'booking_initiated',
    points: 5,
  },
  {
    activityId: 'communication_penalty',
    points: -4,
  },
  {
    activityId: 'lead_inactivity_penalty',
    points: -12,
  },
];
